import { Auth } from 'aws-amplify';
import { setActiveUser, setUserData } from '../redux/users';
import store from '../redux/store';

/**
 * Refreshes the AWS Cognito session.
 * Logs key details and updates Redux store on success.
 * @returns {Promise<boolean>}
 */
export const refreshCognitoSession = async () => {
    console.log("🔄 refreshCognitoSession called");
  
    try {
      const session = await Auth.currentSession();
      const refreshToken = session.getRefreshToken();
      console.log("✅ Current session:", session);
      console.log("🔐 Refresh token:", refreshToken.getToken());
  
      const user = await Auth.currentAuthenticatedUser();
      console.log("👤 Authenticated user:", user);
  
      return new Promise((resolve, reject) => {
        user.refreshSession(refreshToken, async (err, data) => {
          if (err) {
            console.error("❌ Session refresh failed:", err);
            if (store.getState()?.users?.activeUser) {
              // handleLogout(); // Uncomment if using logout
            }
            reject(false);
          } else {
            try {
              const newIdToken = data.getIdToken().getJwtToken();
              console.log("✅ New ID Token after refresh:", newIdToken);
  
              const userInfo = await Auth.currentUserInfo();
              console.log("👤 Refreshed user info:", userInfo);
  
              const userObj = {
                username: user.username,
                attributes: userInfo?.attributes,
                token: newIdToken,
              };
  
              store.dispatch(setActiveUser(true));
              store.dispatch(setUserData(userObj));
  
              resolve(true);
            } catch (userInfoErr) {
              console.error("❌ Error getting user info:", userInfoErr);
              reject(false);
            }
          }
        });
      });
    } catch (e) {
      console.error("❌ Unable to refresh session:", e);
      return false;
    }
  };